import script from "./GolfTripInfoSection.vue?vue&type=script&lang=ts&setup=true"
export * from "./GolfTripInfoSection.vue?vue&type=script&lang=ts&setup=true"

import "./GolfTripInfoSection.vue?vue&type=style&index=0&id=268d572a&lang=scss&scoped=true"
import "./GolfTripInfoSection.vue?vue&type=style&index=1&id=268d572a&lang=scss"

import exportComponent from "/Users/lyon/Desktop/Work s2j/app-rentalcar-project/admin-v3 2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-268d572a"]])

export default __exports__